import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  scChatWindow: {
    display: "flex",
    width: "300px",
    height: "360px",
    position: "fixed",
    right: "100px",
    bottom: "0px",
    boxSizing: "border-box",
    boxShadow: `0px 0px 6px 0px ${theme.iconColor}`,
    backgroundColor: theme.gridBGColor,
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "0.3s ease-in-out",
    borderRadius: "10px 10px 0px 0px",
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    zIndex: "40",
  },
});

const WithChatWindow = (WrappedComponent) =>
  withStyles(styles)((props) => {
    const { classes } = props;
    return (
      <div className={classes.scChatWindow}>
        <WrappedComponent {...props} />
      </div>
    );
  });

export default WithChatWindow;
